import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'

  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'

  import { useRoute, useRouter } from 'vue-router/composables'
  import useIcons from '@/composables/useIcons'
  import useCourse from '@/composables/useCourse'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useGamification from '@/composables/useGamification'
  import useI18n from '@/composables/useI18n'
  import useSegment from '@/composables/useSegment'

  import CourseApi from '@/services/api/CourseApi'

  import { CourseModule } from '@/store/modules/course'
  import { UserModule } from '@/store/modules/user'

  import type { PropType } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'StartCourseForFreeModal',
  props: {
    callback: Function as PropType<() => void>,
    routeToExam: Boolean,
  },
  setup(__props) {

const props = __props;

  

  const route = useRoute()
  const router = useRouter()

  const { checkedCircle } = useIcons()
  const { course, navigateToModule, nextModuleToStart } = useCourse()
  const { inWebExtension, closeModal } = useCommonMixin()
  const { trackGamificationActivity } = useGamification()
  const { translateString } = useI18n()
  const { frontendCourseTrialStarted } = useSegment()

  const startingTrial = ref(false)

  const freeCourseModulesCount = computed(() => {
    const courseModules = CourseModule.coursesModuleMap[course.value!.id]
    return (
      courseModules?.reduce((acc, module) => {
        if (module.isFree) acc++
        return acc
      }, 0) || 0
    )
  })

  const inLessonPage = computed(() => {
    return route.name === 'Lesson'
  })

  const helperItems = [
    translateString('courses.completeAccess', { freeModulesCount: freeCourseModulesCount.value }),
    translateString('courses.unlimitedTime'),
    translateString('courses.notCharged'),
    translateString('courses.availableEverywhere'),
  ]

  const startTrial = () => {
    if (!course.value) return

    startingTrial.value = true
    CourseApi.startCourseTrial([course.value.id])
      .then(() => {
        if (props.callback) props.callback()
        if (CourseModule.course) {
          CourseModule.setCourseTimeTrialStarted(new Date().toISOString())
          CourseModule.setCourseTrial(true)
        }
        if (inWebExtension.value) return
        if (!inLessonPage.value) {
          if (props.routeToExam) {
            router.push(`/courses/${course.value?.id}/exam/${course.value?.exam?.id}/start`)
          } else {
            navigateToModule(course.value!.id, nextModuleToStart.value, null)
          }
        }
        frontendCourseTrialStarted(UserModule.email, course.value!.id, course.value!.title)
        trackGamificationActivity('COURSE_TRIAL_STARTED', {
          courseId: course.value!.id,
          moduleId: null,
          lessonId: null,
        })
      })
      .finally(() => {
        closeModal()
        startingTrial.value = false
      })
  }

return { __sfc: true,props, route, router, checkedCircle, course, navigateToModule, nextModuleToStart, inWebExtension, closeModal, trackGamificationActivity, translateString, frontendCourseTrialStarted, startingTrial, freeCourseModulesCount, inLessonPage, helperItems, startTrial, computed, ref, SVGRenderer, LoadingSpinner, KetchUpButton, useRoute, useRouter, useIcons, useCourse, useCommonMixin, useGamification, useI18n, useSegment, CourseApi, CourseModule, UserModule }
}

})